import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Col, Row, Table } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { ComponentDataTable, Icon } from '../../components';
import { historyShiftAssignmentRequest } from '../../requests/shiftAssignment';
import ShiftAssignmentsHistoryFilters from './ShiftAssignmentsHistoryFilters';

const ChangesExpander = ({ data }) => {
  const { changes } = data;
  if (!changes || Object.keys(changes).length === 0) {
    return <div className="p-3 text-muted">No se detectaron cambios detallados.</div>;
  }

  return (
    <div className="p-3 bg-light border-top border-bottom">
      <h6 className="mb-2" style={{ color: '#2f8c6b' }}>
        <Icon icon="options-outline" className="mr-1" size={16} /> Detalle de Cambios
      </h6>
      <Table bordered hover size="sm" className="mb-0 bg-white" style={{ fontSize: '13px' }}>
        <thead className="thead-light">
          <tr>
            <th style={{ width: '30%' }}>Campo</th>
            <th style={{ width: '35%' }}>Valor Anterior</th>
            <th style={{ width: '35%' }}>Valor Nuevo</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(changes).map(([field, values]) => {
            const oldValue = values[0] === null || values[0] === undefined ? '-' : String(values[0]);
            const newValue = values[1] === null || values[1] === undefined ? '-' : String(values[1]);
            return (
              <tr key={field}>
                <td>
                  <strong>{field}</strong>
                </td>
                <td>{oldValue}</td>
                <td>{newValue}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

const columns = () => [
  {
    name: 'FECHA HORA',
    selector: 'created_at',
    sortable: true,
    grow: '1',
  },
  {
    name: 'COLABORADOR',
    selector: 'employee.full_name',
    cell: (item) => (
      <div>
        <div>{item.employee ? item.employee.full_name : '-'}</div>
        <small className="text-muted">{item.employee ? item.employee.rut : '-'}</small>
      </div>
    ),
    sortable: false,
    grow: '2',
  },
  {
    name: 'TURNO ANTERIOR',
    selector: 'current_shift_name',
    sortable: false,
    grow: '2',
  },
  {
    name: 'TURNO ACTUAL',
    selector: 'assigned_shift_name',
    sortable: false,
    grow: '2',
  },
  {
    name: 'INICIO TURNO',
    selector: 'shift_start',
    sortable: false,
    grow: '1.2',
  },
  {
    name: 'FIN TURNO',
    selector: 'shift_end',
    sortable: false,
    grow: '1.2',
  },
  {
    name: 'TIPO DE EVENTO',
    selector: 'event_label',
    cell: (item) => {
      let badgeClass = 'secondary';
      if (item.event === 'create') badgeClass = 'success';
      if (item.event === 'update') badgeClass = 'info';
      if (item.event === 'destroy') badgeClass = 'danger';
      return <span className={`badge badge-${badgeClass} text-uppercase`}>{item.event_label}</span>;
    },
    sortable: false,
    grow: '1',
  },
  {
    name: 'RESPONSABLE',
    selector: 'whodunnit',
    sortable: false,
    grow: '1.5',
  },
];

const ShiftAssignmentsHistory = () => {
  useEffect(() => window.scrollTo(0, 0), []);
  const dispatch = useDispatch();
  const [paramsFilters, setParamsFilters] = useState({
    date_from: moment().startOf('month').format('DD/MM/YYYY'),
    date_to: moment().format('DD/MM/YYYY'),
  });
  const [moreData, setMoreData] = useState(false);
  const [onRequest, setOnRequest] = useState(false);
  const [historyVersions, setHistoryVersions] = useState([]);
  const [amount, setAmount] = useState(0);

  const handleIndexRequest = (myParams) => {
    setOnRequest(true);
    historyShiftAssignmentRequest({
      dispatch,
      params: {
        display_length: 15,
        ...myParams,
      },
      successCallback: (response) => {
        const { data } = response.data;
        setOnRequest(false);
        setAmount(response.data.metadata.amount);
        setHistoryVersions(data);
      },
      failureCallback: () => {
        setOnRequest(false);
      },
    });
  };

  const handleFilterAdvance = (params) => {
    setParamsFilters(params);
    setMoreData(!moreData);
  };

  const sortColumnCase = (name) => ({ sort_column: name });

  return (
    <>
      <Row className="mt-4 mb-4">
        <Col>
          <h2 className="mt-3 mb-3">Historial de Asignación de Turnos</h2>
        </Col>
      </Row>

      <Row className="mt-2">
        <Col md={12}>
          <ShiftAssignmentsHistoryFilters formRequest={handleFilterAdvance} />
        </Col>
      </Row>

      <ComponentDataTable
        columns={columns()}
        data={historyVersions}
        handleSortCase={sortColumnCase}
        moreData={moreData}
        onRequest={onRequest}
        preName="shift_assignments_history"
        resourceRequest={(params) => {
          handleIndexRequest({ ...params, ...paramsFilters });
        }}
        withDateSelect={false}
        withSearch={true}
        expandableRows
        expandableRowsComponent={<ChangesExpander />}
        totalRows={amount}
      />
    </>
  );
};

export default ShiftAssignmentsHistory;
